export const masterCaseStudies = [
  {
    id: "1",
    product: "InsightsAI, EngageAI, DocsAI",
    industry: "Field Services & Maintenance",
    country: "Singapore",
    tag: "FIELD SERVICES & MAINTENANCE · SINGAPORE",
    client: "Leading Services Company",
    stat: "Closed-Loop AI",
    image: "/images/case-studies/agentic-ai-workforce.jpg",
    title: "An Agentic AI Workforce That Turns Service Data Into the Next Customer Opportunity",
    text: "A leading Singapore services firm deployed the iNextLabs AI Workforce — InsightsAI, EngageAI, and DocsAI — turning service history and handwritten field reports into a closed-loop customer re-engagement engine.",
    url: "https://inextlabs.ai/resources/agentic-ai-workforce-service-data-customer-opportunity",
    outcomes: [
      "Autonomous closed-loop lifecycle: InsightsAI identifies service opportunities, EngageAI triggers outreach, DocsAI digitizes field reports",
      "Handwritten field service reports captured via WhatsApp and transformed into structured CRM data with zero manual entry",
      "Proactive customer re-engagement driven by AI analysis of equipment service validity cycles"
    ]
  },
  {
    id: "2",
    product: "EngageAI",
    industry: "Signage & Product Identification",
    country: "Singapore",
    tag: "SIGNAGE & PRODUCT IDENTIFICATION · SINGAPORE",
    client: "Million Advertising",
    stat: "24/7 ERP Sync",
    image: "/images/case-studies/million-advertising.jpg",
    title: "Million Advertising: Bringing AI-Powered Customer Engagement to Signage Manufacturing",
    text: "Million Advertising partnered with iNextLabs to deploy EngageAI, securely connecting conversational AI with an on-premise ERP to deliver real-time order tracking 24/7.",
    url: "https://inextlabs.ai/resources/million-advertising-ai-customer-service-on-premise-erp",
    outcomes: [
      "24/7 automated order status tracking directly integrated with on-premise ERP",
      "Secure bridge behind corporate firewall without moving sensitive data to the cloud",
      "Award-winning enterprise AI deployment slashing customer support workload"
    ]
  },
  {
    id: "3",
    product: "InsightsAI",
    industry: "Human Resources",
    country: "Singapore",
    tag: "HUMAN RESOURCES · SINGAPORE",
    client: "Adaptive Pay",
    stat: "Conversational HR",
    image: "/images/case-studies/adaptive-pay.jpg",
    title: "Adaptive Pay x iNextLabs: Bringing Enterprise AI to HRMS & Workforce Analytics",
    text: "Adaptive Pay partnered with iNextLabs to embed InsightsAI into its HRMS, enabling conversational natural-language workforce analytics while preserving enterprise security and role-based access.",
    url: "https://inextlabs.ai/resources/adaptive-pay-enterprise-ai-hrms-isv-partnership",
    outcomes: [
      "Conversational natural-language HR analytics and instant workforce metrics access",
      "Strict role-based access control guaranteeing employee data privacy & compliance",
      "Rapid ISV time-to-market without building complex AI data pipelines from scratch"
    ]
  },
  {
    id: "4",
    product: "DocsAI",
    industry: "Wholesale & Distribution",
    country: "Singapore",
    tag: "WHOLESALE & DISTRIBUTION · SINGAPORE",
    client: "Leading Retailer",
    stat: "Exception-Driven",
    image: "/images/resources/case-study/teck-sang-singapore-invoice-verification.png",
    title: "How Leading Retailer Automated Supplier Invoice Verification",
    text: "One of Singapore’s established food importers and wholesale distributors transformed supplier invoice verification with iNextLabs DocsAI, transitioning from manual review to an intelligent, exception-driven AI Workforce.",
    url: "https://inextlabs.ai/resources/teck-sang-singapore-invoice-verification-docsai",
    outcomes: [
      "Automated supplier invoice data extraction and line-item validation against business rules",
      "Exception-driven review routing that flags errors and discrepancies for human verification",
      "Accelerated turnaround cycle and full auditability across expanding supplier document volume"
    ]
  },
  {
    id: "5",
    product: "DocsAI",
    industry: "Electrical Works",
    country: "Singapore",
    tag: "ELECTRICAL WORKS · SINGAPORE",
    client: "Leading Electrical Engineering Firm",
    stat: "Field Digitized",
    image: "/images/resources/case-study/leading-electrical-engineering.webp",
    title: "How a Leading Electrical Engineering Firm in Singapore Digitized Field Reporting",
    text: "Fully digitized maintenance reporting, automatic report organization, faster customer report delivery, and full dashboard visibility across operations for a leading electrical works firm in Singapore.",
    url: "https://inextlabs.ai/resources/singapore-electrical-engineering-digitized-field-reporting",
    outcomes: [
      "100% digital field maintenance report capture with zero manual paperwork",
      "Automated PDF report generation and instant client sign-off delivery",
      "Central operational dashboard with real-time field engineer task tracking"
    ]
  },
  {
    id: "6",
    product: "DocsAI",
    industry: "Financial Services",
    country: "Malaysia",
    tag: "FINANCIAL SERVICES · MALAYSIA",
    client: "Leading Malaysian Bank",
    stat: "50% Faster",
    image: "/images/resources/case-study/bank-rakyat.webp",
    title: "How a Leading Malaysian Bank Cut Document Retrieval Time by 50%",
    text: "Manual document searches and contract reviews were slowing down legal and compliance teams. iNextLabs DocsAI reduced document retrieval time by 50%, automated compliance checks, and accelerated contract reviews.",
    url: "https://inextlabs.ai/resources/malaysia-bank-document-retrieval-docsai",
    outcomes: [
      "50% reduction in compliance search & retrieval cycle time",
      "Automated verification against central regulatory disclosure standards",
      "Full audit trail and secure role-based document access controls"
    ]
  },
  {
    id: "7",
    product: "DocsAI",
    industry: "Manufacturing",
    country: "Global",
    tag: "MANUFACTURING · ACCOUNTS PAYABLE",
    client: "1,200-Employee Global Manufacturer",
    stat: "800% Throughput",
    image: "/images/resources/case-study/matco-asia.webp",
    title: "Manufacturing: Eliminating Invoice Processing Delays & $47K Savings",
    text: "A 1,200-employee manufacturing company struggled with a 3-day invoice processing backlog. After implementing DocsAI, they achieved an 800% increase in invoice throughput with existing staff and eliminated manual entry errors entirely.",
    url: "https://inextlabs.ai/resources/singapore-electrical-engineering-digitized-field-reporting",
    outcomes: [
      "800% throughput increase on multi-vendor invoice parsing",
      "$47,000 in quarterly cost savings from error prevention",
      "Zero backlog with automated 3-way matching into enterprise ERP"
    ]
  },
  {
    id: "8",
    product: "EngageAI",
    industry: "Food and Beverage",
    country: "Malaysia",
    tag: "FOOD & BEVERAGE · MALAYSIA",
    client: "Leading Malaysian Tea Brand (800+ Outlets)",
    stat: "800+ Outlets",
    image: "/images/resources/case-study/222510.webp",
    title: "How a Leading Malaysian Tea Brand Scaled Customer Communication Across 800 Outlets",
    text: "Rapid growth caused communication breakdowns, missed orders, and long wait times during peak hours. iNextLabs EngageAI enabled real-time multilingual customer support on WhatsApp, reducing missed orders and improving customer satisfaction across 800+ outlets.",
    url: "https://inextlabs.ai/resources/malaysia-tea-brand-800-outlets-engageai",
    outcomes: [
      "Multilingual AI ordering and support across 800+ franchise locations",
      "Elimination of missed orders during afternoon rush hours",
      "Seamless integration with point-of-sale and kitchen display systems"
    ]
  },
  {
    id: "9",
    product: "EngageAI",
    industry: "Healthcare",
    country: "Malaysia",
    tag: "HEALTHCARE · MALAYSIA",
    client: "Leading Eye Care Provider in Malaysia",
    stat: "24/7 Triage",
    image: "/images/resources/case-study/eyecare-malaysia.png",
    title: "How a Leading Eye Care Provider in Malaysia Transformed Patient Support",
    text: "A multi-branch eye specialist clinic in Malaysia faced slow patient response times across social channels and WhatsApp. iNextLabs EngageAI delivered 24/7 omnichannel automated patient enquiry handling, appointment management, and Meta Ads auto-replies.",
    url: "https://inextlabs.ai/resources/malaysia-eyecare-patient-support-engageai",
    outcomes: [
      "24/7 automated patient triage and doctor schedule lookup",
      "Automated follow-up reminders cutting no-shows by 32%",
      "Direct auto-reply pipeline for Meta Ads patient leads"
    ]
  },
  {
    id: "10",
    product: "EngageAI",
    industry: "Building Materials",
    country: "India",
    tag: "BUILDING MATERIALS · INDIA",
    client: "Leading Ceramic Tile Distributor (16 Branches)",
    stat: "70% Auto-Resolved",
    image: "/images/resources/case-study/customer-management-experience-meeting-concept.webp",
    title: "How a Leading Ceramic Tile Distributor in Tamil Nadu Improved Customer Engagement Across 16 Branches",
    text: "Manual inquiry handling, no after-hours support, and no social channel coverage. iNextLabs EngageAI resolved 70% of FAQs automatically, increased leads from Google by 20%, and eliminated missed inquiries across 16 branches.",
    url: "https://inextlabs.ai/resources/tamil-nadu-ceramic-tile-distributor-engageai",
    outcomes: [
      "70% automated FAQ resolution across 23 tile brands",
      "20% surge in qualified inbound leads from Google Business Messages",
      "Unified agent portal tracking past conversation history for 16 branches"
    ]
  },
  {
    id: "11",
    product: "WhatsApp",
    industry: "Food and Beverage",
    country: "Singapore",
    tag: "FOOD & BEVERAGE · SINGAPORE",
    client: "Leading Indian Restaurant in Singapore",
    stat: "Zero Rush Delays",
    image: "/images/resources/case-study/help-whatsapp.webp",
    title: "How a Leading Indian Restaurant in Singapore Automated Orders and Customer Queries",
    text: "High call volumes during peak hours and no automated way to handle orders and inquiries. iNextLabs EngageAI automated order processing and customer query handling across WhatsApp, Facebook Messenger, and Google Business Messages.",
    url: "https://inextlabs.ai/resources/singapore-indian-restaurant-automated-orders-engageai",
    outcomes: [
      "Instant WhatsApp voice note & text menu ordering",
      "Automatic POS synchronization and payment gateway confirmation",
      "Zero phone line congestion during peak weekend meal times"
    ]
  },
  {
    id: "12",
    product: "WhatsApp",
    industry: "Retail",
    country: "Singapore",
    tag: "RETAIL · SINGAPORE",
    client: "Leading Jewellery Retailer in Singapore",
    stat: "Lead Nurturing",
    image: "/images/resources/case-study/jewelry-case-study.webp",
    title: "How a Leading Jewellery Retailer in Singapore Increased Customer Engagement on WhatsApp",
    text: "Low customer engagement through traditional marketing channels. iNextLabs EngageAI enabled personalized WhatsApp broadcast messaging, automated lead nurturing, and increased brand awareness.",
    url: "https://inextlabs.ai/resources/singapore-jewellery-retailer-whatsapp-engagement",
    outcomes: [
      "Personalized broadcast campaigns with 98% message open rate",
      "Automated bridal jewelry catalog recommendations on WhatsApp",
      "High-value VIP customer appointment booking automation"
    ]
  },
  {
    id: "13",
    product: "WhatsApp",
    industry: "Hospitality",
    country: "India",
    tag: "HOSPITALITY · INDIA",
    client: "Leading Business Hotel in Coimbatore",
    stat: "24/7 Support",
    image: "/images/resources/case-study/chetinaad.webp",
    title: "How a Leading Business Hotel in Coimbatore Automated Guest Communication",
    text: "Guests expected 24/7 personalized responses but the team could not cover all hours and channels manually. iNextLabs EngageAI enabled round-the-clock guest support across WhatsApp and Google Business Messages, improving booking conversions and reducing staff workload.",
    url: "https://inextlabs.ai/resources/coimbatore-business-hotel-guest-communication-engageai",
    outcomes: [
      "24/7 automated WhatsApp concierge for bookings & room requests",
      "Direct room reservation conversions with zero OTA commission",
      "Staff workload reduction of 45% on repetitive guest queries"
    ]
  },
  {
    id: "14",
    product: "InsightsAI",
    industry: "FMCG",
    country: "India",
    tag: "FMCG · INDIA",
    client: "Leading Organic FMCG Brand",
    stat: "Automated Reminders",
    image: "/images/resources/case-study/jewelry-employee-working-laptop.webp",
    title: "How a Leading Organic FMCG Brand Automated Payment Reminders and Reduced Late Payments",
    text: "Manual invoice follow-ups were causing payment delays and consuming team time. iNextLabs EngageAI automated WhatsApp payment reminders via CRM integration, reducing late payments and eliminating manual follow-up work.",
    url: "https://inextlabs.ai/resources/organic-fmcg-brand-payment-reminders-engageai",
    outcomes: [
      "Automated WhatsApp payment reminder workflows triggered by CRM dues",
      "35% drop in overdue distributor payment cycles",
      "Complete elimination of manual bookkeeping and reminder calls"
    ]
  },
  {
    id: "15",
    product: "InsightsAI",
    industry: "Financial Services",
    country: "India",
    tag: "FINANCIAL SERVICES · INDIA",
    client: "Leading Investment Management Firm",
    stat: "High Open Rates",
    image: "/images/resources/case-study/character-holding-green-arrow-tree-with-money.webp",
    title: "How an Investment Management Firm Replaced Email Marketing with EngageAI on WhatsApp",
    text: "Email marketing was being marked as spam and failing to reach clients. iNextLabs EngageAI enabled personalized WhatsApp campaigns with automated delivery, improving engagement and message deliverability.",
    url: "https://inextlabs.ai/resources/investment-management-firm-whatsapp-engageai",
    outcomes: [
      "Zero spam folder loss with direct verified WhatsApp Business delivery",
      "Interactive CTA buttons for market updates and fund allocations",
      "Data-driven client segmentation based on campaign interaction rates"
    ]
  },
  {
    id: "16",
    product: "InsightsAI",
    industry: "Fitness",
    country: "India",
    tag: "FITNESS · INDIA",
    client: "Leading Bangalore Gym Chain",
    stat: "Zero Lead Drop-off",
    image: "/images/resources/case-study/notepad-with-text-strong-brand-equity.webp",
    title: "How a Leading Bangalore Gym Increased Customer Engagement and Reduced Missed Leads",
    text: "High volume of unanswered inquiries after marketing campaigns was causing leads to drop off. iNextLabs EngageAI enabled instant responses, reduced call volume, and eliminated lead drop-off at the first touchpoint.",
    url: "https://inextlabs.ai/resources/bangalore-gym-customer-engagement-engageai",
    outcomes: [
      "Instant response within 3 seconds for digital ad campaign leads",
      "Automated free trial booking & gym location mapping",
      "40% increase in membership trial-to-conversion rates"
    ]
  },
  {
    id: "17",
    product: "EngageAI",
    industry: "Non-Profit",
    country: "India",
    tag: "NON-PROFIT · INDIA",
    client: "Leading Education Crowdfunding Non-Profit",
    stat: "2-Day Funding",
    image: "/images/resources/case-study/map-lying-wooden-table.webp",
    title: "How a Leading Education Crowdfunding Non-Profit Raised Money Faster for Underprivileged Students",
    text: "Low donor response rates and slow fundraising through email campaigns. iNextLabs EngageAI enabled proactive WhatsApp notifications with one-click donations, completing causes in 2 days instead of a week.",
    url: "https://inextlabs.ai/resources/india-education-nonprofit-fundraising-whatsapp",
    outcomes: [
      "Proactive WhatsApp donation alerts with 1-click payment links",
      "Cause completion cycle time slashed from 7 days to 48 hours",
      "Automated donor tax receipt generation and thank-you sequences"
    ]
  },
  {
    id: "18",
    product: "WhatsApp",
    industry: "Hospitality",
    country: "India",
    tag: "HOSPITALITY · INDIA",
    client: "Leading Serviced Apartment Brand in Coimbatore",
    stat: "Lower CPL",
    image: "/images/resources/case-study/staff-hotel-meeting-guest.webp",
    title: "How a Leading Serviced Apartment Brand in Coimbatore Improved Guest Experience and Booking Conversions",
    text: "Slow response times were causing prospective guests to book elsewhere. iNextLabs EngageAI enabled 24/7 guest support across WhatsApp and Google Business Messages, improving lead conversion and reducing cost per lead.",
    url: "https://inextlabs.ai/resources/coimbatore-serviced-apartment-booking-conversions-engageai",
    outcomes: [
      "24/7 instant rate quote & apartment layout sharing on WhatsApp",
      "28% increase in direct extended-stay guest bookings",
      "Substantial reduction in cost-per-lead compared to aggregator listings"
    ]
  }
];
